import { request } from '../utils/axios'


export function loginApi(data) {
  return request({
    url: '/api/Login/Logins',
    method: 'post',
    data
  })
}
export function updPwdApi(data) {
  return request({
    url: '/api/Login/UpdPwd',
    method: 'post',
    data
  })
}

export function getObjects(params) {
  return request({
    url: '/api/Main/getNewsDetail',
    method: 'get',
    params
  })
}

export function getDutyList(params) {
  return request({
    url: '/api/Main/Duty',
    method: 'get',
    params
  })
}

export function getMeetingList() {
  return request({
    url: '/api/Courseware/MainVideoList',
    method: 'get'
  })
}
